export default function loadGPT(win = window) {
  if (win.googletag && win.googletag.apiReady) {
    return Promise.resolve(win.googletag);
  }

  return new Promise((resolve, reject) => {
    win.googletag = win.googletag || {};
    win.googletag.cmd = win.googletag.cmd || [];

    const tag = win.document.createElement('script');
    tag.src = '//securepubads.g.doubleclick.net/tag/js/gpt.js';
    tag.onerror = e => {
      reject(e);
    };

    win.document.getElementsByTagName('head')[0].appendChild(tag);

    win.googletag.cmd.push(() => {
      win.googletag.pubads().disableInitialLoad();
      win.googletag.pubads().enableSingleRequest();
      win.googletag.pubads().collapseEmptyDivs();
      win.googletag.enableServices();
      resolve(win.googletag);
    });
  });
}



// WEBPACK FOOTER //
// ./src/ads/gpt-loader.js